export enum PicoAppEnum {
  PICO_COM = "pico-com",
  CHLAST_PICO = "chlast-pico",
  KUKANA_PICO = "kukana-pico",
  SIPKY_PICO = "sipky-pico",
  BEERRALLY_PICO = "beerrally-pico",
  KDESU_PICO = "kdesu-pico",
  SKLADKA_PICO = "skladka-pico",
}
